module.exports = __webpack_public_path__ + "static/img/tab1.7914aca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/championscity/challenge/tab1.png
// module id = /KRu
// module chunks = 1